<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Cambiar contraseña a: {{ this.user }}</h5>
        </div>        
        <emt-form ref="reassignment-form" v-bind:items="itemsFormActivityReassignment" v-bind:resource="itemResource" v-bind:typeactivity="typeactivity"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form-register-user'
import swal from 'sweetalert2'

export default{
    name: 'emt-change-password',
    data: function () {
        return {
            itemsFormActivityReassignment: [
                {
                    'name': 'password',
                    'label': 'Contraseña nueva',
                    'placeholder': 'Ingrese nueva contraseña',
                    'value': null,
                    'maxlength': '50',
                    'type': 'password',
                    'errors': []
                }, {
                    'name': 'password_two',
                    'label': 'Confirme su nueva contraseña',
                    'placeholder': 'Confirme su nueva contraseña',
                    'value': null,
                    'maxlength': '50',
                    'type': 'password',
                    'errors': []
                }
            ],
            itemResource: [
                {
                    'resourcePassword': '/change_password/'
                }
            ],
            typeactivity: 'changePassword',
            user: ''
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        this.getUser()
        generic.setToken()
    },
    methods: {
        getUser: function () {
            var self = this
            self.$http.get(Config.api + '/user/?nopaginate=1&id=' + self.$route.params.id).then(function (response) {
                self.user = response.body[0].username
            }, function (response) {
                swal({
                    title: 'Se presento un problema',
                    text: '',
                    type: 'danger',
                    confirmButtonText: 'Aceptar'
                })
            })
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-change-password.vue?295ed0c6